import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the PipesFiltroPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'pipesFiltroColor',
})
export class PipesFiltroColorPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(arreglo: any[], texto: string = '', arregloPrincipal: any[]): any[] {

    if ( texto === '') {
      return arregloPrincipal;
    }

    if (!arregloPrincipal) {
      return arreglo;
    }
    texto = texto.toLocaleLowerCase();
    return arregloPrincipal.filter( item => item.color.toLowerCase().includes(texto))

  }
}



// WEBPACK FOOTER //
// ./src/pipes/pipes-filtro-color/pipes-filtro-color.ts